import { FaMapMarkerAlt } from 'react-icons/fa';

const MapButton = ({ onClick }) => (
  <button
    className="rounded p-2 font-semibold map-button border uppercase text-sm text-gray-600 border-gray-300"
    onClick={onClick}
  >
    <FaMapMarkerAlt className="inline-block text-base -mt-1" /> View On Map
  </button>
);

export default MapButton;
